import axios from "axios";

export const getMapConfiguration = (careersClientId) => {
  return axios
    .get(
      import.meta.env.VITE_ACTIVATE_BACKEND_API +
        "/api/map/getmapconfiguration/" +
        encodeURIComponent(careersClientId)
    )
    .then((res) => res.data);
};

export const editMapConfiguration = (data) => {
  return axios
    .post(
      import.meta.env.VITE_ACTIVATE_BACKEND_API + "/api/map/editmapconfiguration",
      data
    )
    .then((res) => res.data);
};
